import { FunctionComponent, ReactNode } from "react";
import { Navbar } from "@App/Components/Navbar";
import { Outlet } from "react-router-dom";
import { Footer } from "@App/Layouts/Footer";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "@App/state";
import { getConfig } from "@App/utils/getConfig";

export type DefaultPartnerLayoutProps = {
  logos: {
    left?: {
      component: ReactNode | ReactNode[];
    };
    right?: {
      component: ReactNode | ReactNode[];
    };
  };
  backToPartnerButton?: {
    url: string;
  };
};

export const DefaultPartnerLayout: FunctionComponent<DefaultPartnerLayoutProps> = ({
  logos,
  backToPartnerButton,
}: DefaultPartnerLayoutProps) => {
  const { t } = useTranslation();
  const organization = useSelector((state: State) => state.orders.organization);
  const { legal } = getConfig(organization);

  return (
    <div className="text-neutral-900">
      <Navbar>
        <div className={"flex items-center gap-5"}>
          {logos.left?.component}
          {backToPartnerButton && (
            <a
              href={backToPartnerButton.url}
              className="hidden md:flex gap-1 items-center text-xs text-neutral-700 font-normal no-underline border border-neutral-300 rounded p-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                viewBox="0 0 20 20"
                fill="#2f3237"
              >
                <path
                  fillRule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
              {t("layout.backText")}
            </a>
          )}
        </div>
        {logos.right?.component}
      </Navbar>
      <Outlet />
      <Footer privacyPolicyUrl={legal.privacyPolicyUrl} />
    </div>
  );
};
